import { render, staticRenderFns } from "./CharityNicheIcon.vue?vue&type=template&id=687bfe88&scoped=true"
import script from "./CharityNicheIcon.vue?vue&type=script&lang=js"
export * from "./CharityNicheIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687bfe88",
  null
  
)

export default component.exports